import React from 'react';
import '../../App.css';
import Footer from '../Footer';
import { Button } from '../button';
import './Branding.css';
import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import CardItem from '../CardItem';
import {Helmet} from "react-helmet";
    

function Branding () {
    
    const { Branding } = useLocation();
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [Branding]);
  

    return (
        <>

          <Helmet>
          <meta charSet='utf-8'/>
          <title>Tekins | Branding Estratégico</title>
          <meta name="description" content= "Construimos sistemas de identidad y brandbooks que conectan propósito, diseño y crecimiento de negocio." />
          <meta name="robots" content= "index, follow"></meta>
          </Helmet>

        <div className='branding-home'>
       
        <h1> Branding estratégico</h1> 
           
        <p>Diseñamos marcas vivas que evolucionan con tu negocio y se sostienen en cada punto de contacto.</p> 
        
        </div>
        <div className='container'>
                  
                        <p>El branding es la forma en que tu marca conversa con el mundo. Desde el propósito hasta la ejecución en canales, definimos un sistema coherente y escalable que conecta personas, producto y negocio.
                        </p>
                     
                    <h2 >Piensa en una marca que admires.<br/> ¿Qué te hizo recordarla?</h2>
                         <p>Más allá del logo o los colores, se trata de la experiencia completa. En Tekins conectamos investigación, estrategia y diseño para que cada interacción refuerce la promesa y genere confianza.
                            </p>
        </div>
       
        <div className='container-01'>
                <h1> Conoce nuestros paquetes de branding</h1>
               
        </div>

        <div className='row-01'>
          
            <div className='col-01'>
            <div className='col-title'>
            <h1> Paquete Standard</h1> 
            </div>
                    <div className='col-content'>   
                    <ul>
                    <li>Diseño de logo y sus variantes </li>
                    <li>Tipografías</li>
                    <li>Paleta de colores</li>
                    <li>Moodboard</li>
                    <li>Highlights (6 iconos)</li>
                    <li>Diseño 6 plantillas para redes sociales.</li>
                    <li>Objetivos y palabras claves de tu marca.</li>
                    <li>Herramientas claves para tu Instagram.</li>
                    <li>Manual de Identidad y Estilo</li>
                    <li>Diseño de tarjeta de presentación (1)</li>
                    </ul>
                    </div>
                    <div className='col-time'>   
                    <h4>Entrega: 2 - 3 semanas</h4>
                    </div>
                    
                    <div className='col-button'><a target="_blank" href="https://api.whatsapp.com/send?phone=50761107470&text=Quiero%20comprar%20paquetestandard"> <button className='bt' >Cotizar</button> </a></div>
                    
            </div>
        </div>
        <div className='row-01-r'>
            
            <div className='col-01-r'>
            <div className='col-title-r'>
            <h1> Paquete Brandbook </h1> 
            </div>
                    <div className='col-content-r'>   
                    <ul>                          
                   <li>Diseño de logo y sus variantes</li> 
                   <li>Tipografías</li> 
                   <li>Paleta de colores</li> 
                   <li>Moodboard</li> 
                   <li>Highlights (6 iconos)</li> 
                   <li>Diseño 6 plantillas para redes sociales.</li> 
                   <li>Objetivos y palabras claves de tu marca.</li> 
                   <li>Herramientas claves para tu Instagram.</li> 
                   <li> Historia de la marca</li>
                   <li>Misión y visión</li> 
                   <li>Papelería (6 diseños, por ej: stickers, empaque, hoja membretada)</li> 
                   <li>Manual de Identidad y Estilo</li> 
                   <li>Diseño de tarjeta de presentación (1)</li> 
                 </ul>
                    </div>
                    <div className='col-time-r'>   
                    <h4>Entrega: 3 - 4 semanas</h4>
                    </div>
                    
                    <div className='col-button-r'><a target="_blank" href="https://api.whatsapp.com/send?phone=50761107470&text=Quiero%20comprar%20Brandbook"> <button className='bt' >Cotizar</button> </a></div>
                    
            </div>
            
        </div>
        <div className='row-01-r'>
            
            <div className='col-01-r'>
            <div className='col-title-r'>
            <h1> Paquete Papeleria </h1> 
            </div>
                    <div className='col-content-r'>   
                    <ul>                          
                   <li>Tarjetas de presentación</li> 
                   <li>Sobres</li> 
                   <li>Stickers</li> 
                   <li>Folders</li> 
                   <li>Hangtags</li> 
                   <li>Merch</li> 
                   <li>Carta/Menú</li> 
                   <li>Afiches</li> 
                   <li>Flyers</li>
                   <li>Entre otros</li> 
                   <li>Invitaciones</li> 
                   <li>Cajas</li> 
                   
                 </ul>
                    </div>
                    <div className='col-time-r'>   
                    <h4>Entrega: 3 - 4 semanas</h4>
                    </div>
                    
                    <div className='col-button-r'><a target="_blank" href="https://api.whatsapp.com/send?phone=50761107470&text=Quiero%20comprar%20Brandbook"> <button className='bt' >Cotizar</button> </a></div>
                    
            </div>
            
        </div>
        <div className='portafolio-contenido'>
        <div className='cards__container'>
        <div className='cards__wrapper'>
           <ul className='cards__items'>
           <CardItem
              src='images/santarita-01.jpg'
              text='Santa Rita'
              
              path='/Santarita'
            />
         
         
          <CardItem
              src='images/mercadovera-01.jpg'
              text='Mercado de Vera'
              
              path='/Mercadodevera'
            />
            <CardItem
              src='images/photozulem-01.jpg'
              text='Katherine Zulem'
             
              path='/Photozulem'
            />
           <CardItem
              src='images/zulemevent-01.jpg'
              text='Zulem Events'
              
              path='/Zulemevents'
            />
            <CardItem
              src='images/azucenas-01.jpg'
              text='Azucena’s'
             
              path='/Azucenas'
            />
          </ul>
          </div>
          </div>
</div>
               
        <Footer/>
        </>
    );
}

export default Branding;

